import axios from "axios";
import { PBX_API_ORIGIN } from "@/lib/apiConfig";

// Demo requests go to the main OwnPBX backend (the same one serving signup
// and the live demo widget). The old REACT_APP_BACKEND_URL was never set in
// the Netlify build, so bookings were posted to "undefined/api/leads" and
// failed for every visitor. Leads are read inside the console, behind login —
// there is deliberately no public way to list them from the website.
export const createLead = (data) =>
  axios.post(`${PBX_API_ORIGIN}/api/public/leads`, data).then((r) => r.data);
